import React, { memo } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { attachFileToNote } from 'utils/actions/notes'
import { Checkbox } from 'components/forms'
import { DocumentIcon } from 'transfix-icons'
import { filePromises } from 'utils/fileUploadHelper'
import { formatActivityDateTime } from 'utils/formatDatetime'
import { parseNoteTags } from 'utils/parseNoteTags'

export const Note = memo(
  ({
    note: { id, creatorName, createdAt, callBackAt, body, documents = [] },
    last,
    callback,
    handleCallback,
  }) => {
    const dispatch = useDispatch()
    const callbackClass = callback ? 'text-secondary strike' : 'text-secondary mr2'
    const fileUploadHandler = e => {
      const {
        target: { files },
      } = e
      if (files) {
        const fileList = Array.from(files)
        Promise.all(filePromises(fileList)).then(packageFiles => {
          packageFiles.forEach(file => {
            dispatch(
              attachFileToNote(id, {
                documentFileName: file.fileFileName,
                document: file.file,
              })
            )
          })
        })
      }
    }
    return (
      <div className='note-entry mb3'>
        <div className='pv0'>
          <strong>{creatorName}</strong>{' '}
          <span className='text-secondary'>{formatActivityDateTime(createdAt)}</span>
          <label
            className='btn-fileinput btn-text-link'
            htmlFor={`note-file-upload-${id}`}
            id={`note-file-upload-${id}`}
            data-test='upload-note-files'>
            <input
              type='file'
              id={`note-file-upload-${id}`}
              name={`note-file-upload-${id}`}
              accept='.pdf, .jpg, .jpeg, .png, .doc, .docx, .tiff, .txt'
              onChange={fileUploadHandler}
              multiple
            />
            Attach File
          </label>
        </div>
        <div>
          <span
            className='text-default'
            dangerouslySetInnerHTML={{ __html: parseNoteTags({ body }) }}
          />{' '}
          {/* eslint-disable-line react/no-danger */}
          {documents.map(document => {
            const { documentName, documentUrl } = document
            return (
              <div key={documentName} className='document'>
                <DocumentIcon size='large' />
                <a href={documentUrl} target='_blank' rel='noopener noreferrer' className='ma2'>
                  {documentName}
                </a>
              </div>
            )
          })}
        </div>
        {callBackAt && (
          <div className='flex'>
            <span className={callbackClass}>Callback: {formatActivityDateTime(callBackAt)}</span>
            {!callback && (
              <Checkbox
                id='callback'
                dataTest='callback-toggle'
                checked={callback}
                onChange={handleCallback}
              />
            )}
          </div>
        )}
      </div>
    )
  }
)

export const notePropType = PropTypes.shape({
  id: PropTypes.number,
  creatorName: PropTypes.string,
  createdAt: PropTypes.string,
  callBackAt: PropTypes.string,
  body: PropTypes.string,
})

Note.propTypes = {
  note: notePropType.isRequired,
  last: PropTypes.bool,
}

Note.defaultProps = {
  last: false,
}
